import { Footer as BronsonReactFooter } from "@vwfs-bronson/bronson-react";
import React from "react";
import { useTranslation } from "react-i18next";

export const Footer: React.FunctionComponent = () => {
  const { t } = useTranslation("footer");
  return (
    <>
      <BronsonReactFooter role="contentinfo">
        <BronsonReactFooter.ModuleMetaNav
          metaSectionLabel={t("footer-link-hidden-title")}
          copyrightText={t("copyright", {
            year: new Date().getFullYear(),
          })}
        >
          <BronsonReactFooter.ModuleMetaNav.Item
            href={t("links.legal-notice")}
            normalLink={true}
            linkProps={{ target: "_blank", rel: "noopener noreferrer" }}
          >
            {t("legal-notice")}
          </BronsonReactFooter.ModuleMetaNav.Item>

          <BronsonReactFooter.ModuleMetaNav.Item
            href={t("links.cookie-policy")}
            normalLink={true}
            linkProps={{ target: "_blank", rel: "noopener noreferrer" }}
          >
            {t("cookie-policy")}
          </BronsonReactFooter.ModuleMetaNav.Item>

          <BronsonReactFooter.ModuleMetaNav.Item
            href={t("links.privacy-policy")}
            normalLink={true}
            linkProps={{ target: "_blank", rel: "noopener noreferrer" }}
          >
            {t("privacy-policy")}
          </BronsonReactFooter.ModuleMetaNav.Item>

          <BronsonReactFooter.ModuleMetaNav.Item
            href={t("links.accessibility")}
            normalLink={true}
            linkProps={{ target: "_blank", rel: "noopener noreferrer" }}
          >
            {t("accessibility")}
          </BronsonReactFooter.ModuleMetaNav.Item>
        </BronsonReactFooter.ModuleMetaNav>
        <BronsonReactFooter.ModuleFootnotes footerText={t("footnote")} />
      </BronsonReactFooter>
    </>
  );
};

export default Footer;
